export default "__VITE_ASSET__0e7df72f__"